<!-- Div is for Top Branding Bar -->
<div class="fixed-top">

  <!-- Responsive Bootstrap Standard Nav-Bar, Menu Bar -->
  <nav class="navbar navbar-expand-lg navbar-dark" id="zsd_navbar">

    <!--contains brand image-->
    <div class="navbar-brand" id="zsd_logo_container">
      <img id="zsd_logo" *ngIf="imageLoaded" src={{zsdLogoSrc}} height="55.5" width="56" (click)="gotoDefaultPage()">  
    </div>

    <button #navbarToggler class="navbar-toggler" id="zsd_navbar_toggler" type="button" data-toggle="collapse"
      data-target=".navbar-collapse">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Navigation bar for menus - Store, Requests, User profile dropdown -->
    <div class="collapse navbar-collapse" id="zsd_navbar_menus">
      <!-- Store and My Requests menu links-->
      <ul class="navbar-nav mr-auto">
        <!-- Link for Home -->        
        <li class="nav-item">
          <a class="nav-link" id="zsd_home" [routerLink]='["/home"]' routerLinkActive="active"
            (click)="collapseNav('zsd_home')">
            <span class="d-none d-lg-block menu-link-text"><em class="fas fa-home"></em></span>
            <span class="menu-link-text d-lg-none"> {{ 'Banner.home' |translate }} </span>
          </a>
        </li>
        <!-- Link for Store -->
        <li class="nav-item" *ngIf="showStoreNavMenu">
          <a class="nav-link" id="zsd_store" [routerLink]='["/store"]' routerLinkActive="active"
            (click)="collapseNav('zsd_store')">
            <span class="menu-link-text"> {{ 'Banner.store' |translate }} </span>
          </a>
        </li>
        <!-- Link for Requests -->
        <li class="nav-item" *ngIf="showRequestNavMenu">
          <a class="nav-link" id="zsd_requests" [routerLink]='["/requests"]' routerLinkActive="active"
            (click)="collapseNav('zsd_requests')">
            <span class="menu-link-text"> {{ 'Banner.requests' |translate }} </span>
          </a>
        </li>
        <!-- Link for Services -->
        <li *ngIf="showServiceTab" class="nav-item">
          <a class="nav-link" id="zsd_services" [routerLink]='["/services"]' routerLinkActive="active"
            (click)="collapseNav('zsd_services')">
            <span class="menu-link-text" aria-label="Services"> {{ 'Banner.services' |translate }} </span>
          </a>
        </li>
        <!-- Link for Items -->
        <li *ngIf="showItemTab" class="nav-item">
          <a class="nav-link" id="zsd_items" [routerLink]='["/items"]' routerLinkActive="active"
            (click)="collapseNav('zsd_items')">
            <span class="menu-link-text" aria-label="Items"> {{ 'Banner.items' |translate }} </span>
          </a>
        </li>
        <!-- Link for Self Help -->
        <li class="nav-item">
          <a class="nav-link" id="zsd_selfhelp" [routerLink]='["/selfhelp"]' routerLinkActive="active"
            (click)="collapseNav('zsd_selfhelp')">
            <span class="menu-link-text" aria-label="Self Help"> {{ 'Banner.selfhelp' |translate }} </span>
          </a>
        </li>

        <!-- Link for Outages -->
        <li *ngIf="showOutagesTab" class="nav-item">
          <a class="nav-link" id="zsd_outages" [routerLink]='["/outages"]' routerLinkActive="active"
            (click)="collapseNav('zsd_outages')">
            <span class="menu-link-text" aria-label="Outages"> {{ 'Banner.outages' |translate }} </span>
          </a>
        </li>

        <!-- Link for New Request -->
        <li  *ngIf="canCreateIncidents || canCreateServiceRequests || canCreateChangeRequests" class="nav-item d-none d-lg-block">
          <a class="nav-link" id="zsd_reportIncident" data-toggle="tooltip" data-placement="left"
            title="{{ 'Banner.reportIncident' | translate }}" [routerLink]='["/newrequest"]' routerLinkActive="active"
            (click)=loadNewRequestCreationPage()>
            <span><em class="fa fa-edit fa-lg"></em></span>
          </a>
        </li>
      </ul>

      <!-- User profile dropdown-->
      <!-- <ul class="">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle d-none d-lg-block" id="zsd_profile_dropdown" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" href="#"><span data-toggle="tooltip" title="{{username}}"><i
                class="fa fa-user fa-lg"></i></span></a>

          <a class="nav-link dropdown-toggle d-lg-none" id="zsd_profile_dropdown" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" href="#">{{username}}</a> -->
          <!-- User profile dropdown menus - My-Profile & Signout -->
          <!-- <div class="dropdown-menu dropdown-menu-right" id="zsd_custom_profile_dropdown">
            <a id="zsd_myProfile" class="dropdown-item" [routerLink]='["/my-profile"]'
              (click)="collapseNav('zsd-profile')">
              <span class="menu-link-text" id="dropdown-menu-link-text">{{ 'Banner.myProfile' |translate }}</span>
            </a>
            <a id="zsd_signOut" class="dropdown-item" role="button" (click)="logOut()">
              <span class="menu-link-text"navbar-nav navbar-right id="dropdown-menu-link-text"> {{ 'Banner.signOut' |translate }} </span>
            </a>
          </div>
        </li>
      </ul> -->

      <div class="navbar-nav nav-link dropdown">
        <button class="btn btn-override dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
         aria-haspopup="true" aria-expanded="false">
          <em class="fa fa-user fa-lg"></em>
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="nav-item dropdown-item" href="#" id="zsd_myProfile" [routerLink]='["/my-profile"]'
          (click)="collapseNav('zsd-profile')">{{ 'Banner.myProfile' |translate }}</a>
          <a class="nav-item dropdown-item" role="button" id="zsd_signOut" (click)="logOut()">{{ 'Banner.signOut' |translate }}</a>
        </div>
      </div>

      <!-- Help Icon -->
      <ul class="navbar-nav navbar-right">
        <li class="nav-item">
          <a class="nav-link" id="zsd_help" routerLinkActive="active" target="_blank" href={{helpURL}}>
            <span class="d-none d-lg-block" id="zsd_help_icon"><em class="fa fa-question-circle fa-lg"></em></span>
            <span class="menu-link-text d-lg-none"> {{ 'Banner.help' |translate }} </span>
          </a>
        </li>
      </ul>
    </div>

    <!-- Search Bar -->
    <!-- Collpased Mode - Only Search Icon with String Search <Page Name > will display -->
    <ul *ngIf="collapsedMode && showGolbalSearchBar" class="navbar-nav navbar-right" id="search_icon">
      <li class="nav-item">
        <form id="zsd_search" class="form-inline nav-link" style="display:inline-block">
          <input class="form-control" type="search" aria-label="Search" id="inputbox" (focus)="searchBarExpand()"
            (blur)="searchBarInCollapsedView()" name="searchTerm" [(ngModel)]="searchTerm" autocomplete="off" required>
        </form>
      </li>
    </ul>

    <!-- Search dropdown-->
    <!-- Expanded Mode - Displying with Drop down -->

    <ul *ngIf="!collapsedMode && showGolbalSearchBar" class="navbar-nav navbar-right" id="zsd_search_bar" #search>
      <li class="nav-item" id="search_icon_onexpand">
        <form id="zsd_searchexpand" class="form-inline nav-link" style="display:inline-block">
          <input class="form-control" type="search" aria-label="Search" id="inputbox_expand"
            (keyup.enter)="clickSearch()" title="{{ searchPlaceholderonExpand | translate}}" name="searchTerm"
            placeholder="{{ searchPlaceholderonExpand | translate}}" [(ngModel)]="searchTerm" autocomplete="off"
            required>
          <button class="close-icon" type="reset"></button>
        </form>
      </li>
      <li class="nav-item dropdown" id="zsd_search_dropdown">
        <button type="button" class="btn zsd_dropdown_button" data-toggle="dropdown" id="btn_search_dropdown"
          #zsdSearchDropdown>
          {{searchPageString | translate}}
        </button>
        <button type="button" class="btn btn-info btn-sm" (click)="searchBarInCollapsedView()" id="btn_collapse_search">
          &times;
        </button>
        <div class="dropdown-menu dropdown-menu-right search_dr opdown_item" id="search_dropdown_menu">
          <span class="dropdown-item" (click)="chooseSearchPage('store') ; expandSearchbar()"
            *ngIf="showStoreNavMenu">{{ 'Banner.store' | translate}}</span>
          <span class="dropdown-item" (click)="chooseSearchPage('requests'); expandSearchbar()"
            *ngIf="showRequestNavMenu">{{'Banner.requests' | translate}}</span>
          <span class="dropdown-item"
            (click)="chooseSearchPage('services'); expandSearchbar()">{{'Banner.services' | translate}}</span>
          <span class="dropdown-item"
            (click)="chooseSearchPage('selfhelp'); expandSearchbar()">{{'Banner.selfhelp' | translate}}</span>
          <span class="dropdown-item" (click)="chooseSearchPage('items'); expandSearchbar()"
            *ngIf="showItemTab">{{'Banner.items' | translate}}</span>
          <span *ngIf="canCustomerViewOutages" class="dropdown-item"
            (click)="chooseSearchPage('currentoutages'); expandSearchbar()">{{'Banner.outages' | translate}}</span>
          <span *ngIf="canCusotmerViewPlannedOutages" class="dropdown-item"
            (click)="chooseSearchPage('plannedoutages'); expandSearchbar()">{{'Banner.plannedOutages' | translate}}</span>
        </div>
      </li>
    </ul>
    <!-- Create Request Link -->
      <ul class="navbar-nav d-lg-none" id="zsd_reportIncident_icon">
        <li class="nav-item" *ngIf="canCreateIncidents || canCreateServiceRequests || canCreateChangeRequests">
          <a class="nav-link" id="zsd_reportIncident" data-toggle="tooltip" data-placement="left"
            title="{{ 'Banner.reportIncident' | translate }}" [routerLink]='["/newrequest"]' routerLinkActive="active"
            (click)=loadNewRequestCreationPage()>
            <span><em class="fa fa-edit fa-lg"></em></span>
          </a>
        </li>
      </ul>
  </nav>

  <div #alertBar id="zsd_alert_bar">
    <zsd-alert></zsd-alert>
  </div>

</div>

<div id="zsd_banner_router">
  <router-outlet></router-outlet>
</div>
